module.exports = __webpack_public_path__ + "static/underDino-7b2e66b4467b6119910b5b979716ac10.jpeg";